import { DatabasePlusIcon } from './DatabasePlusIcon';

/**
 * author: Simran
 * id 940D2514-B309-4CE0-A2E4-D02121415CA3
 * name database-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/database-plus.svg
 * tags
 * - Geographic Information System 
 * - Database 
 */
export const DatabaseAddIcon = DatabasePlusIcon;
export default DatabaseAddIcon